import faucetsImg from "@/public/images/GlobalVisualSearch/category/faucets/faucets_category.png"
import toiletsImg from "@/public/images/GlobalVisualSearch/category/toilets/toilets_category.png"
import showersImg from "@/public/images/GlobalVisualSearch/category/showers/showers_category.png"
import valvesImg from "@/public/images/GlobalVisualSearch/category/valves/valves_category.png"
import servicePartsImg from "@/public/images/GlobalVisualSearch/category/service-parts/service_parts_category.png"
import bathsImg from "@/public/images/GlobalVisualSearch/category/baths/bath_category.png"
import showerDoorsImg from "@/public/images/GlobalVisualSearch/category/shower-doors/shower_doors_category.png"
import sinksImg from "@/public/images/GlobalVisualSearch/category/sinks/sinks_category.png"
import fucetPartsImg from "@/public/images/GlobalVisualSearch/category/faucet-parts/faucet-parts-subcategory.png"
import toiletPartsImg from "@/public/images/GlobalVisualSearch/category/toilet-parts/toilet-parts-subcategory.png"
import otherPartsImg from "@/public/images/GlobalVisualSearch/category/other-parts/other-parts-subcategory.png"

export const productCategories = [
  {
    name: "faucets",
    value: "faucets",
    image: faucetsImg,
    isComingSoon: false,
  },
  {
    name: "toilet",
    value: "toilet",
    image: toiletsImg,
    isComingSoon: false,
  },
  {
    name: "shower",
    value: "shower",
    image: showersImg,
    isComingSoon: false,
  },
  {
    name: "valve",
    value: "valve",
    image: valvesImg,
    isComingSoon: false,
  },
  {
    name: "serviceParts",
    value: "serviceParts",
    image: servicePartsImg,
    isComingSoon: false,
  },
  {
    name: "baths",
    value: "bath",
    image: bathsImg,
    isComingSoon: true,
  },
  {
    name: "showerDoors",
    value: "shower door",
    image: showerDoorsImg,
    isComingSoon: true,
  },
  {
    name: "sinks",
    value: "sink",
    image: sinksImg,
    isComingSoon: true,
  },
]

export const productSubCategories = [
  {
    name: "faucetParts",
    value: "servicepart-faucet",
    image: fucetPartsImg,
    isComingSoon: false,
  },
  {
    name: "toiletParts",
    value: "servicepart-toilet",
    image: toiletPartsImg,
    isComingSoon: false,
  },
  {
    name: "otherParts",
    value: "servicepart-shower",
    image: otherPartsImg,
    isComingSoon: false,
  },
]
